var _circle, _g, _g2, _path, _g3, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeEscutaInicial = function SvgIconeEscutaInicial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 16,
    transform: "matrix(-1 0 0 1 18 17)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31403)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 16,
    transform: "matrix(-1 0 0 1 18 17)",
    fill: "#FBC7D5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3606 12C14.8236 12 12.2865 12.3595 9.74932 13.0784C9.13578 13.2523 8.71429 13.7961 8.71429 14.4138V22.5776C8.71429 23.3462 9.35921 23.9693 10.1548 23.9693L10.1812 23.969L10.2316 23.9681L13.0502 23.4778C13.0502 23.4778 14.9945 23.1332 17.3561 23.1332C19.7177 23.1332 21.662 23.4778 21.662 23.502L24.4913 23.9681C25.2766 24.0131 25.9509 23.4346 25.9975 22.6759C25.9992 22.6488 26 22.6216 26 22.5945V14.4133C26 13.7958 25.5787 13.2521 24.9654 13.0781C22.4322 12.3594 19.8972 12 17.3606 12Z",
    fill: "#FEECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6369 15.4791V16.8732L15.1909 16.876V18.265L16.6369 18.2651V19.654H18.0774V18.265H19.5204V16.876H18.0774V15.4791H16.6369Z",
    fill: "#FEECF1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4962 14.5929V16.3245L14.7643 16.3279V18.0532L16.4962 18.0533V19.7786H18.2216V18.0532H19.95V16.3279H18.2216V14.5929H16.4962Z",
    fill: "#C8206F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_31403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2501 9.50037C29.2501 9.00087 29 8.75074 28.5001 8.75037H22.5001C22.0059 8.75074 21.7561 9.00087 21.7501 9.50037V14.7504L21.7568 15.87C21.7578 16.033 21.9397 16.1294 22.0752 16.0388L24.0001 14.75H28.5001C29 14.75 29.2501 14.4999 29.2501 14V9.50037Z",
    fill: "#F888AE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4999 13.2149C25.5548 13.2144 25.6206 13.188 25.6973 13.1356C26.4115 12.598 27.2045 12.1011 27.2045 11.1696C27.2045 10.5955 26.792 10.1477 26.267 10.1477C25.9704 10.1477 25.6857 10.2982 25.4999 10.5341C25.3141 10.2982 25.0295 10.1477 24.7329 10.1477C24.2079 10.1477 23.7954 10.5955 23.7954 11.1696C23.7954 12.111 24.6241 12.6176 25.3046 13.1356C25.3799 13.1891 25.445 13.2157 25.4999 13.2149Z",
    fill: "#FEECF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31403",
    x: 0.222222,
    y: 0.111111,
    width: 35.5556,
    height: 35.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.329412 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31403",
    x: 7.84995,
    y: 11.1357,
    width: 19.0143,
    height: 13.6992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.513726 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31403",
    x: 20.9319,
    y: 7.93218,
    width: 9.13636,
    height: 8.95967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.409091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.329412 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31403",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeEscutaInicial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-escuta-inicial.7c0a3763.svg";
export { ForwardRef as ReactComponent };